export const FREE_PLAN_LIMIT = 1
export const FREE_PLAN_USERS = 1
